(function(){

    class ControlledObject{
        constructor(){
            this._outcomes = [];
            this._rng = undefined;
        }

        setRng(rng){
            this._rng = rng;
        }

        addOutcome( outcomeToAdd, chanceToAdd ) {
            this._outcomes.push( {
                outcome: outcomeToAdd,
                chance: chanceToAdd
            });            
        }

        pickOutcome(callback, excludedOutcomes) {
            excludedOutcomes = excludedOutcomes || [];
            let totalChance = this.getTotalChance(excludedOutcomes);
            let runningTotal = 0;
            let self = this;
            this._rng(function(index) {
                for (let i = 0; i < self._outcomes.length; ++i) {
                    if (excludedOutcomes.indexOf(self._outcomes[i].outcome) === -1){
                        runningTotal += self._outcomes[i].chance;
                        if (runningTotal>index){
                            callback(self._outcomes[i].outcome);
                            return;
                        }
                    }
                }
            }, [{ incLow : 0 , excHi : totalChance}]);
        }

        getTotalAvailableOutcomes(){
            let res =0;
            for (let i = 0; i < this._outcomes.length; ++i){
                if (this._outcomes[i].chance > 0)
                    ++res;
            }
            return res;
        }

        getTotalChance(excludedOutcomes) {
            let totalChance = 0;
            for (let i = 0; i < this._outcomes.length; ++i){
                if (excludedOutcomes.indexOf(this._outcomes[i].outcome) === -1){
                    totalChance += this._outcomes[i].chance;
                }
            }
            return totalChance;
        }
    }

    module.exports = function(){
        let res = new ControlledObject();
        res.setRng(gdk.rngGeneratorNonCritical);
        return res;
    }

}());